import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app.jsx';
import AppStore from './app-store';
import { Provider } from 'react-redux';

/*******************************************************************************
 * Render the app
 */

const container = document.getElementById( 'app-root' );
const root = createRoot( container );

root.render(
	<Provider store={ AppStore() }>
		<App />
	</Provider>
);